module.exports = __webpack_public_path__ + "img/1.0f491299.png";